import { t } from 'i18next'

import { AreaCode } from '@enechain/eposition-proto/bfftypes/v1/area_pb'

/**
 * 先物(EEX)の対応エリア
 */
export const EEX_SUPPORTED_AREAS: readonly AreaCode[] = [
  AreaCode.TOKYO,
  AreaCode.KANSAI,
] as const

/**
 * 現物の対応エリア
 */
export const PHYSICAL_SUPPORTED_AREAS: readonly AreaCode[] = Object.values(
  AreaCode,
).filter(
  (value): value is AreaCode =>
    typeof value === 'number' && value !== AreaCode.UNSPECIFIED,
) as readonly AreaCode[]

export function convertAreaLabelFromAreaCode(value: AreaCode): string {
  switch (value) {
    case AreaCode.HOKKAIDO:
      return t('domain:shared.area.hokkaido')
    case AreaCode.TOHOKU:
      return t('domain:shared.area.tohoku')
    case AreaCode.TOKYO:
      return t('domain:shared.area.tokyo')
    case AreaCode.CHUBU:
      return t('domain:shared.area.chubu')
    case AreaCode.HOKURIKU:
      return t('domain:shared.area.hokuriku')
    case AreaCode.KANSAI:
      return t('domain:shared.area.kansai')
    case AreaCode.CHUGOKU:
      return t('domain:shared.area.chugoku')
    case AreaCode.SHIKOKU:
      return t('domain:shared.area.shikoku')
    case AreaCode.KYUSHU:
      return t('domain:shared.area.kyushu')
    case AreaCode.UNSPECIFIED:
    default:
      return t('domain:shared.area.unspecified')
  }
}
